/* eslint-disable @next/next/no-img-element */

// components
import { Container } from 'components/Grid';
import { MirandaGradientButton } from '@/components/Button';
import { VideoPlayer } from '@/containers-m/VideoPlayer';

// styles
import {
  SectionWrapper,
  LogoWrapper,
  TitleWrapper,
  MediaWrapper,
  ContenCopy,
  CTAWrapper,
  Title,
  Description,
} from './FreightSection.styles';

//logo
import FIAI from '@/public/images/logos/logo-freightintel-ai-black.svg';

export function FreightSection() {
  const video_settings = {
    youtube: 'https://www.youtube.com/watch?v=_rf7_1NE8-M?rel=0',
    thumb: '/images/home/freightintel/freightintelai-thumb.jpg',
    preview: '/videos/home/bg_fiai_promotion.webm',
  };

  return (
    <SectionWrapper>
      <Container>
        <LogoWrapper>
          <FIAI width="418" height="48" />
        </LogoWrapper>
        <TitleWrapper>
          <Title>Unlocking Insights with advanced machine learning</Title>
          <Description>
            FreightIntel AI acts like a seasoned transportation expert,
            automatically accessing data within your TMS and delivering
            immediate insights at the click of a button.
          </Description>
        </TitleWrapper>

        <MediaWrapper>
          <VideoPlayer content={video_settings} />
        </MediaWrapper>

        <ContenCopy>
          <p>
            By leveraging the logistics data already in ShipperGuide TMS,
            alongside Loadsmart’s trusted benchmarking dataset and cutting-edge
            AI technology, it provides tailored observations and actionable
            recommendations unique to your business. FreightIntel AI harnesses
            advanced machine learning to analyze complex datasets, detect
            patterns, and offer personalized guidance in real time.
          </p>
        </ContenCopy>

        <CTAWrapper>
          <MirandaGradientButton as="a" href="#hubspot-form">
            <span>Request a Demo</span>
          </MirandaGradientButton>
        </CTAWrapper>
      </Container>
    </SectionWrapper>
  );
}
